export function EmptyIcon(props) {
	return (
		<svg
			width="64"
			height="64"
			viewBox="0 0 64 64"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M32.0003 41.3335C29.0537 41.3335 26.667 43.7868 26.667 46.8002V50.6668H37.3337V46.8002C37.3337 43.7868 34.947 41.3335 32.0003 41.3335Z"
				fill="#FF8837"
			/>
			<path
				d="M32.0137 40C34.2228 40 36.0137 38.2091 36.0137 36C36.0137 33.7909 34.2228 32 32.0137 32C29.8045 32 28.0137 33.7909 28.0137 36C28.0137 38.2091 29.8045 40 32.0137 40Z"
				fill="#FF8837"
			/>
			<path
				d="M44.0003 18.6669H35.8003L39.9203 7.12019C40.1737 6.42685 39.8003 5.66685 39.107 5.41352C38.4137 5.16019 37.6537 5.52019 37.4003 6.22685L32.9603 18.6802H20.0003C19.267 18.6802 18.667 19.2802 18.667 20.0135V54.6802C18.667 55.4135 19.267 56.0135 20.0003 56.0135H44.0003C44.7337 56.0135 45.3337 55.4135 45.3337 54.6802V20.0002C45.3337 19.2669 44.7337 18.6669 44.0003 18.6669ZM42.667 53.3335H21.3337V21.3335H32.0137L31.5203 22.7202C30.2803 22.9469 29.3337 24.0269 29.3337 25.3335C29.3337 26.8002 30.5337 28.0002 32.0003 28.0002C33.467 28.0002 34.667 26.8002 34.667 25.3335C34.667 24.6802 34.427 24.0802 34.027 23.6135L34.8403 21.3335H42.667V53.3335Z"
				fill="#FF8837"
			/>
			<path
				d="M27.4135 16.4533C27.6135 17 28.1202 17.3333 28.6668 17.3333C28.8135 17.3333 28.9735 17.3066 29.1202 17.2533C29.8135 17 30.1735 16.24 29.9335 15.5466L26.6002 6.21331C26.3468 5.51997 25.5868 5.15997 24.8935 5.39997C24.2001 5.65331 23.8401 6.41331 24.0801 7.10664L27.4135 16.44V16.4533Z"
				fill="#FF8837"
			/>
		</svg>
	);
}
